<template>
    <div class="automation-action-settings">
        <div class="field">
            <small>
                {{ t('automations-form-actions-task-snippets_help') }}
            </small>
            <small>
                <ul>
                    <li class="token" v-for="(token, t) in tokens" :key="t">
                        <span class="copy-token">{{ token }}</span>
                        <a @click="copyToken(token)" class="copy-btn"
                            ><i class="fa fa-copy"></i
                        ></a>
                    </li>
                </ul>
            </small>
        </div>
        <div class="field" v-if="boards.length">
            <label> {{ t('automations-form-actions-task-board_label') }} </label>

            <select v-model="task.tasksBoardsId" class="form-control">
                <option value="">{{ t('automations-form-actions-task-board_placeholder') }}</option>
                <option
                    v-for="board in boards"
                    :value="board.id"
                    :key="board.id"
                >
                    {{ board.name }}
                </option>
            </select>
        </div>
        <div class="field">
            <label> {{ t('automations-form-actions-task-task_title_label') }} </label>

            <input class="form-control" v-model="task.title" />
        </div>
        <div class="field">
            <label> {{ t('automations-form-actions-task-deadline_label') }} </label>

            <input class="form-control" type="tel" v-model="task.deadline" />
        </div>
        <div class="field">
            <label> {{ t('automations-form-actions-task-description_label') }} </label>

            <textarea
                class="form-control"
                v-model="task.description"
            ></textarea>
        </div>
        <div class="field">
            <label
                ><input type="checkbox" v-model="hasMessageSuggestion" />
                {{ t('automations-form-actions-task-has_message_suggestion_label') }}</label
            >
        </div>
        <div class="field" v-if="hasMessageSuggestion">
            <div class="field" v-if="$module('ai')">
                <label
                    ><input type="checkbox" v-model="task.useChatGenerator" />
                    {{ t('automations-form-actions-task-use_ai_label') }}</label
                >
            </div>
            <template v-if="!task.useChatGenerator">
                <label>{{ t('automations-form-actions-task-message_suggestion_label') }} </label>
                <textarea
                    v-model="task.messageSuggestion"
                    class="form-control"
                ></textarea>
            </template>
            <template v-else>
                <label>{{ t('automations-form-actions-task-ai_prompt_label') }}</label>
                <small>
                    {{ t('automations-form-actions-task-ai_prompt_help') }}
                </small>
                <textarea
                    v-model="task.aiPrompt"
                    class="form-control"
                ></textarea>
            </template>
        </div>
        <div class="field">
            <label>{{ t('automations-form-actions-task-responsible_label') }}</label>
            <small>{{ t('automations-form-actions-task-responsible_help') }}</small>

            <small v-if="userCustomFields.length > 0 || $module('roles')"
                ><label class="radio-label"
                    ><input
                        type="radio"
                        v-model="task.assignMethod"
                        value="manual"
                    />
                    <span>{{ t('automations-form-actions-task-assign_methods-manual') }}</span></label
                ></small
            >
            <small v-if="$module('roles')"
                ><label class="radio-label"
                    ><input
                        type="radio"
                        v-model="task.assignMethod"
                        value="by_role"
                    />
                    <span>{{ t('automations-form-actions-task-assign_methods-by_role') }}</span></label
                ></small
            >
            <small
                v-if="$module('client_fields') && userCustomFields.length > 0"
                ><label class="radio-label"
                    ><input
                        type="radio"
                        v-model="task.assignMethod"
                        value="by_custom_field"
                    />
                    <span>{{ t('automations-form-actions-task-assign_methods-by_custom_field') }}</span></label
                ></small
            >

            <div class="row" v-if="task.assignMethod === 'by_role'">
                <div class="col-6">
                    <label>
                        <small>{{ t('automations-form-actions-task-role_label') }}</small>
                    </label>

                    <select v-model="task.assignRoleId" class="form-control">
                        <option value="">{{ t('automations-form-actions-task-role_placeholder') }}</option>
                        <option
                            v-for="role in roles"
                            :key="role.id"
                            :value="role.id"
                        >
                            {{ role.title }}
                        </option>
                    </select>
                </div>
                <div class="col-6" v-show="branches.length > 1">
                    <label>
                        <small>{{ t('automations-form-actions-task-branch_label') }}</small>
                    </label>
                    <select
                        v-model="task.assignBranchRule"
                        class="form-control"
                    >
                        <option value="last">{{ t('automations-form-actions-task-branch_rules-last') }}</option>
                        <option value="first">{{ t('automations-form-actions-task-branch_rules-first') }}</option>
                        <option value="all">{{ t('automations-form-actions-task-branch_rules-all') }}</option>
                    </select>
                </div>
            </div>
            <div
                class="row"
                v-else-if="task.assignMethod === 'by_custom_field'"
            >
                <div class="col-12">
                    <label>
                        <small>{{ t('automations-form-actions-task-custom_field_label') }}</small>
                    </label>
                    <select
                        class="form-control"
                        v-model="task.assignCustomField"
                    >
                        <option value="">{{ t('automations-form-actions-task-custom_field_placeholder') }}</option>
                        <option
                            v-for="field in userCustomFields"
                            :value="field.id"
                            :key="field.id"
                        >
                            {{ field.field_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-6">
                    <label>
                        <small>{{ t('automations-form-actions-task-user_label') }}</small>
                    </label>

                    <select class="form-control" v-model="task.assignUserId">
                        <option value="">{{ t('automations-form-actions-task-user_placeholder') }}</option>
                        <option
                            v-for="user in users"
                            :key="user.id"
                            :value="user.id"
                        >
                            {{ user.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <input id="tokenToCopy" v-model="tokenToCopy" type="text" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {},
        properties: {},
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-task-title"),
            description: this.t("automations-form-actions-task-description"),
            task: this.properties.task
                ? { ...this.properties.task }
                : {
                      title: "",
                      description: "",
                      messageSuggestion: "",
                      aiPrompt: "",
                      useChatGenerator: false,
                      deadline: null,
                      assignMethod: "manual",
                      assignUserId: "",
                      assignRoleId: "",
                      assignBranchRule: "last",
                      assignCustomField: "",
                      tasksBoardsId: "",
                  },
            hasMessageSuggestion:
                !!this.properties.task?.messageSuggestion ||
                !!this.properties.task?.useChatGenerator,
            tokenToCopy: null,
            customFields: [],
            boards: [],
        };
    },
    async mounted() {
        this.$store.dispatch("placeDetails/setPlace", this.placeId);
        this.loadFields();
        await this.loadBoards();
        this.$emit("mounted", this);
    },
    computed: {
        placeId() {
            return this.$store.state.place.id;
        },
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
        userCustomFields() {
            return this.customFields.filter((f) => f.type === "user");
        },
        ...mapState("placeDetails", ["users", "roles", "branches"]),
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async loadBoards() {
            let options = keviApi.getOptions("/task-boards", "GET");
            const response = await this.$http(options);
            this.boards = response.data;
        },
        loadFields() {
            const options = keviApi.getOptions("client-fields", "GET");
            return this.$http(options).then((response) => {
                this.customFields = response.body;
            });
        },
        changed: function () {
            this.$emit("propertiesUpdated", { task: { ...this.task } });
        },
        isValid: function () {
            if (!this.task.title) {
                return false;
            }
            if (
                this.task.assignMethod === "by_role" &&
                !this.task.assignRoleId
            ) {
                return false;
            }
            if (
                this.task.assignMethod === "by_role" &&
                !this.task.assignRoleId
            ) {
                return false;
            }
            if (
                this.task.assignMethod === "by_custom_field" &&
                !this.task.assignCustomField
            ) {
                return false;
            }
            return true;
        },
        copyToken(token) {
            this.tokenToCopy = token;
            this.$nextTick(() => {
                let tokenToCopyInput = document.querySelector("#tokenToCopy");
                tokenToCopyInput.select();
                if (document.execCommand("copy")) {
                    this.$store.dispatch("notification/success", {
                        text: this.t("automations-form-actions-task-token_copied"),
                        duration: 5000,
                    });
                }
            });
        },
    },
    watch: {
        task: {
            deep: true,
            handler() {
                this.changed();
            },
        },
        properties: function () {
            if (
                JSON.stringify(this.properties.task) !==
                JSON.stringify(this.task)
            ) {
                this.task = this.properties.task
                    ? { ...this.properties.task }
                    : {
                          title: "",
                          description: "",
                          messageSuggestion: "",
                          aiPrompt: "",
                          deadline: null,
                          assignMethod: "manual",
                          useChatGenerator: false,
                          assignUserId: null,
                          assignRoleId: null,
                          assignBranchRule: "last",
                          assignCustomField: "",
                          tasksBoardsId: "",
                      };
                this.hasMessageSuggestion =
                    !!this.properties.task?.messageSuggestion ||
                    !!this.properties.task?.useChatGenerator;
            }
        },
    },
};
</script>
<style scoped lang="less">
.radio-label {
    display: flex;
    align-items: center;
    input {
        margin-top: 0;
        margin-right: 10px;
    }
}
</style>
